import React, { useEffect } from "react";
import LoginForm from "../../components/Auth/LoginForm";

export default function LoginPage() {
	useEffect(() => {
		// Send any analytics
	}, []);

	return <LoginForm />;
}
